import React, { useState, useEffect } from 'react';
import { addCategory } from '../../services/AdminCategoryService';
import { validateCategory } from '../../validations/admin/AdminCategoryValidation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import CategoryForm from '../../forms/categories/CategoryForm';
import '../../styles/AdminModal.css';

const CategoryAddModal = ({ isOpen, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({ name: '', is_default: false });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const isFormValid = formData.name.trim() !== '';

  useEffect(() => {
    if (!isOpen) {
      setFormData({ name: '', is_default: false });
      setErrors({});
      setError('');
    }
  }, [isOpen]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSave = async () => {
    const validationErrors = validateCategory(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setLoading(true);
    setErrors({});
    setError('');
    try {
      await addCategory(formData);
      await onSuccess();
      onClose();
    } catch (error) {
      console.error('Error adding category:', error);
      setError(error.message || 'Error adding category. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="admin__modal">
      <div className="admin__modal-content">
        <div className="admin__modal-intro">
          <h2>Add Category</h2>
          <button className="admin__modal-close" onClick={onClose}>
            <FontAwesomeIcon icon={faClose} />
          </button>
        </div>
        {error && <div className="error-message">{error}</div>}
        <div className="admin__modal-body">
          <CategoryForm formData={formData} handleChange={handleChange} errors={errors} />
        </div>
        <div className="admin__modal-buttons">
          <button className="button secondary" onClick={onClose} disabled={loading}>
            {loading ? 'Saving...' : 'Cancel'}
          </button>
          <button className="button" onClick={handleSave} disabled={loading || !isFormValid}>
            {loading ? 'Saving...' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CategoryAddModal;